/*
 * MappingAdminPage Messages
 *
 * This contains all the text for the MappingAdminPage component.
 */

import { defineMessages } from 'react-intl';
import { TABS } from './constants';

export const scope = 'app.pages.MappingAdminPage';

const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Data Mapping Admin - TPICAP TCA',
  },
  metaDesc: {
    id: `${scope}.metaDesc`,
    defaultMessage:
      'Data Mapping Administration page for managing field mappings and transformations',
  },
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Data Mapping Admin',
  },
  ratesFieldMappingHeader: {
    id: `${scope}.ratesFieldMappingHeader`,
    defaultMessage: 'Rates Field Mapping',
  },
  ratesFixingProxyMappingHeader: {
    id: `${scope}.ratesFixingProxyMappingHeader`,
    defaultMessage: 'Rates Fixing Proxy Mapping',
  },
  legalEntityMappingHeader: {
    id: `${scope}.LegalEntityMappingHeader`,
    defaultMessage: 'Legal Entity Mapping',
  },
  importFromFileButton: {
    id: `${scope}.importFromFileButton`,
    defaultMessage: 'Import from file',
  },
  exportButton: {
    id: `${scope}.exportButton`,
    defaultMessage: 'Export',
  },
  editButton: {
    id: `${scope}.editButton`,
    defaultMessage: 'Edit',
  },
  accessDeniedTitle: {
    id: `${scope}.accessDeniedTitle`,
    defaultMessage: 'Access Denied',
  },
  accessDeniedMessage: {
    id: `${scope}.accessDeniedMessage`,
    defaultMessage: "You don't have permissions to access this page.",
  },
  systemGeneratedValueTooltip: {
    id: `${scope}.systemGeneratedValueTooltip`,
    defaultMessage: 'This is a system generated value and can’t be edited.',
  },
  primaryKeyTooltip: {
    id: `${scope}.primaryKeyTooltip`,
    defaultMessage:
      'This value uniquely identifies this record and can’t be edited.',
  },
});

export const TAB_HEADER_MESSAGES = {
  [TABS.RATES_FIELD]: messages.ratesFieldMappingHeader,
  [TABS.RATES_FIXING]: messages.ratesFixingProxyMappingHeader,
  [TABS.LEGAL_ENTITY]: messages.legalEntityMappingHeader,
};

export default messages;
